<template>
  <span :style="fontStyle"></span>
</template>

<script>
export default {
  name: 'FontPreload',
  props: {
    fontName: {
      type: String,
      required: true,
    },
  },
  computed: {
    fontStyle() {
      return {
        fontFamily: `'${this.fontName}', sans-serif`,
      };
    },
  },
};
</script>
